<template>
  <div class="sm:p-3 md:p-10 lg:p-20 text-center">
    <h1 class="text-4xl font-bold mb-2 text-gray-800 underline">About</h1>
    <div class="flex sm:flex-wrap overflow-hidden">
      <div class="w-1/2 overflow-hidden p-2">
        <img
          class="sm:w-32 sm:h-32 md:w-48 md:h-48 lg:w-64 lg:h-64 ml-auto rounded-md lg:mr-20 md:mr-10 sm:mr-12"
          src="../assets/images/Profile@2x.png"
        />
      </div>

      <div class="container mx-auto w-1/2 overflow-hidden text-left">
        <!-- <h1 class="text-4xl font-bold mb-2 text-gray-800 underline">About</h1> -->
        <p class="text-gray-600 py-2">Hi there. I'm Jaaki</p>

        <p
          class="text-gray-600 py-2"
        >I'm happiest when creating things. Wheither it's a solution for your business problem, or perhaps creating the next big thing.</p>

        <p class="text-gray-600">Creative problem solving and following intuition, driven by passion, executing with precision.</p>
        <p class="text-gray-600 py-2">
          So what happens when you mix:
          Art + Electronics + Software + a Different way of looking at things with a need to make a difference?
        </p>

        <p class="text-gray-600 py-2">
          "A monkey on a mission"
        </p>
      </div>
    </div>
  </div>
</template>



<script>
export default {
  components: {}
};
</script>